let signaturePackaging = [
  'ENVELOPED',
  'ENVELOPING',
  'DETACHED',
  'INTERNALLY_DETACHED'
]

export default signaturePackaging
